import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';
import { useFormikContext } from 'formik';

const SlopeLength = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  const { setFieldValue } = useFormikContext();

  return (
    <FormikInput
      id="slopeLength"
      name="slopeLength"
      label="Slope Length"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter slope length"
      onChange={e => setFieldValue('slopeLength', e.target.value)}
    />
  );
};

export default SlopeLength;
